/**
 * Convert a `tag` URL slug to a Contentful tag value.
 *
 * - Decodes any URL encoding (e.g. "dog%20care" -> "dog care").
 * - Replaces dashes with spaces so URL slugs match Contentful tag values that
 *   commonly contain spaces (e.g. "dog-care" -> "dog care").
 * - Collapses whitespace and trims.
 */
export const tagFromSlug = (raw: string): string => {
	let decoded = raw;
	try {
		decoded = decodeURIComponent(raw);
	} catch {
		decoded = raw;
	}
	return decoded.replaceAll('-', ' ').replaceAll(/\s+/g, ' ').trim();
};

/**
 * Convert a Contentful tag value into a URL slug.
 *
 * - Trims and lowercases.
 * - Collapses internal whitespace to single dashes.
 * - URI-encodes the result so any remaining special characters are safe.
 */
export const tagToSlug = (tag: string): string => encodeURIComponent(tag.trim().toLowerCase().replaceAll(/\s+/g, '-'));

/**
 * Title-case a single tag for display ("dog care" -> "Dog Care").
 */
export const tagToTitle = (value: string): string =>
	value.replaceAll(/\w\S*/g, (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase());
